// src/utils/stateManager.js

const APP_STATE_KEY_PREFIX = 'comprehensiveTaxApp.state_'; // Using your prefix + a year suffix

/**
 * Saves the application state for a specific year to local storage.
 * @param {object} state The application state to save.
 * @param {number} year The tax year to save under.
 */
export const saveStateToLocalStorage = (state, year) => {
  if (!year) return; // Do not save if no year is selected
  try {
    const serializedState = JSON.stringify(state);
    // --- CHANGE: Use a dynamic key based on the year ---
    localStorage.setItem(`${APP_STATE_KEY_PREFIX}${year}`, serializedState);
  } catch (e) {
    console.error("Could not save state to localStorage for year:", year, e);
  }
};

/**
 * Loads the application state for a specific year from local storage.
 * @param {number} year The tax year to load.
 * @returns {object | undefined} The parsed state object or undefined if not found.
 */
export const loadStateFromLocalStorage = (year) => {
  if (!year) return undefined; // Do not load if no year is selected
  try {
    // --- CHANGE: Use a dynamic key to load the correct year's data ---
    const serializedState = localStorage.getItem(`${APP_STATE_KEY_PREFIX}${year}`);
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (e) {
    console.error("Could not load state from localStorage for year:", year, e);
    return undefined;
  }
};
